"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEventRateLimiter = createEventRateLimiter;
const timer_1 = require("../../tools/timer");
const timeUtils_1 = require("../../tools/utils/timeUtils");
const error_types_1 = require("../error/error.types");
function createEventRateLimiter(eventType, limit, onLimitReached) {
    let eventCount = 0;
    let allowNextEvent = false;
    return {
        isLimitReached() {
            if (eventCount === 0) {
                (0, timer_1.setTimeout)(() => {
                    eventCount = 0;
                }, timeUtils_1.ONE_MINUTE);
            }
            eventCount += 1;
            if (eventCount <= limit || allowNextEvent) {
                allowNextEvent = false;
                return false;
            }
            if (eventCount === limit + 1) {
                allowNextEvent = true;
                try {
                    onLimitReached({
                        message: `Reached max number of ${eventType}s by minute: ${limit}`,
                        source: error_types_1.ErrorSource.AGENT,
                        startClocks: (0, timeUtils_1.clocksNow)(),
                    });
                }
                finally {
                    allowNextEvent = false;
                }
            }
            return true;
        },
    };
}
//# sourceMappingURL=createEventRateLimiter.js.map